import useDebounce from "./useDebounce";

/**
 * Arama kutusu için debounce + "bekliyor" bayrağı.
 * `pending`: yazılan değer henüz gecikmeli değere yansımadı — liste bu sırada
 * eski sonucu göstermesin, iskelet çizsin (`busy = pending || isFetching`).
 *
 * @returns {{ debounced: any, pending: boolean }}
 */
export default function useDebouncedSearch(value, delay = 300) {
  const debounced = useDebounce(value, delay);
  return { debounced, pending: value !== debounced };
}
